<div [formGroup]="form">
  <div class="flex-row-generic">
    <!-- Preferred Laboratories -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-preferred-laboratories">Preferred Laboratories</label>
      <ap-findcontrol
        id="{{ baseId }}-preferred-laboratories"
        controlName="PreferredLaboratoriesUid"
        findControlDisplayName="Find Laboratory"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="isPreferredLaboratoriesFindControlRequired"
        [findControlId]="findControlIdService.ListLaboratory"
        [findControlMaxLength]="50"
        [(selectedPks)]="preferredLaboratoriesPks"
        (dirty)="preferredLaboratoriesControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Preferred Laboratories -->

    <!-- Non-Participating Providers -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-non-participating-providers">Non-Participating Providers</label>
      <ap-findcontrol
        id="{{ baseId }}-non-participating-providers"
        findControlDisplayName="Find Provider"
        controlName="RelInsuranceCarrierProviderExclusion"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="isNonParticipatingProvidersFindControlRequired"
        [findControlId]="FindControlIdService.ViewProvider"
        [findControlMaxLength]="50"
        [(selectedPks)]="nonParticipatingProvidersPks"
        (dirty)="nonParticipatingProvidersControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Non-Participating Providers-->
  </div>
</div>
